import { createAction } from '@af-common/Common/_actions/Action';

export enum WindowActionType {
	OnWindowResize	= 'ON_WINDOW_RESIZE'
}

export const OnWindowResize = (width: number, height: number) => createAction(WindowActionType.OnWindowResize, {
	width: width,
	height: height
});

export type WindowAction = ReturnType<typeof OnWindowResize>